<style lang="scss">
.bounce-enter-active {
    transform: scale(2);
    opacity: 0;
    transition: all 0.3s;
}
.bounce-leave-active {
    transform: scale(1.5);
    opacity: 0;
    transition: all 0.3s;
}
.login-panel.modal {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    .modal-dialog {
        width: 430px;
        background-color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 2px;
        transform: translate(-50%, -50%);
        overflow: hidden;
    }
    .close-btn {
        float: right;
        margin-top: 12px;
        cursor: pointer;
    }
}
.modal-header {
    height: 40px;
    background-color: #efefef;
    line-height: 40px;
    padding: 0 16px;
    font-size: 12px;
    color: #c00;
}
#quickLogin {
    .modal-content {
        min-height: 100px;
        padding: 40px 0;
        .form-control {
            width: 350px;
            margin: auto;
        }
        .input-control {
            width: 100%;
            height: 32px;
            border: 1px solid #b8b8b8;
            font-size: 0;
            overflow: hidden;
            position: relative;
            &:first-child {
                margin-bottom: 20px;
            }
            input {
                border: none;
                height: 100%;
                width: 100%;
                vertical-align: middle;
                font-size: 12px;
                display: inline-block;
                padding: 0 15px;
            }
            .email {
                width: 250px;
            }
            .addon {
                width: 100px;
                height: 100%;
                position: absolute;
                right: 0;
                top: 0;
                text-align: center;
                font-size: 12px;
                color: #434354;
                line-height: 32px;
                background-color: #f3f3f3;
            }
        }
        .btn {
            outline: none;
            padding: 0;
            margin: 0;
            cursor: pointer;
            &.btn-lg {
                border: none;
                color: white;
                width: 100%;
                height: 32px;
                font-size: 12px;
                margin-top: 30px;
                background-color: #d19f4e;
            }
        }
    }
}
.error {
    font-size: 12px;
    color: #c00;
    position: absolute;
    margin-top: 8px;
}
</style>

<template>
    <transition name="bounce">
        <div class="login-panel modal" id="quickLogin" v-if="show">
            <div class="modal-dialog">
                <div class="modal-header">
                    登录超时，请重新输入密码
                    <i class=" icons icon-close-big close-btn" @click="close"></i>
                </div>
                <div class="modal-content">
                    <div class="form-control">
                        <div class="input-control">
                            <input type="text" class="email" disabled :value="email | prefix">
                            <span class="addon">@vip.sohu.com</span>
                        </div>
                        <div class="input-control">
                            <input type="password" class="password" placeholder="输入密码" v-model="password">
                        </div>
                        <p class="error" v-if="errorInfo">{{errorInfo}}</p>
                        <button class="btn btn-lg" @click="quickLogin">登 录</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { login } from '@/service/loginService'
import utils from '@/common/utils'
import router from '@/router/index'
import store from '@/store/index'

export default {
    name: 'quickLogin',
    data() {
        return {
            show: false,
            password: '',
            errorInfo: ''
        }
    },
    computed: {
        email() {
            let username = utils.getStorage('username')
            utils.clearStorage('username')
            return username
        }
    },
    created() {
        store.commit('login', false)
    },
    methods: {
        close() {
            this.show = false
            router.replace('/login')
        },
        quickLogin() {
            login({
                userid: this.email,
                password: utils.md5(this.password),
            }, res => {
                if (res.data.status !== 200) {
                    this.errorInfo = '验证失败，请重新登录'
                    setTimeout(() => {
                        this.close()
                    }, 1000)
                } else {
                    store.commit('login', true)
                    utils.setStorage('username', this.email)
                    this.show = false
                    setTimeout(() => {
                        router.go(0)
                    })

                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/quick-login/quick-login.vue